document.addEventListener("DOMContentLoaded", function () {
  const swiperContainersRecipes = document.querySelectorAll(
    ".ig-inner-container .swiper-container"
  );
  swiperContainersRecipes.forEach((container) => {
    const sectionId = container.id.replace("swiper_", "");

    const swiperRecipes = new Swiper(container, {
      observer: true,
      simulateTouch: true,
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "bullets",
      },
      breakpoints: {
        410: {
          slidesPerView: 1,
          spaceBetween: 5,
        },
        510: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        710: {
          slidesPerView: 3,
          spaceBetween: 12,
        },
        1060: {
          slidesPerView: 3,
          spaceBetween: 12,
        },
        1190: {
          slidesPerView: 4,
          spaceBetween: 14,
        },
        1340: {
          slidesPerView: 5,
          spaceBetween: 14,
        },
      },
    });

    swiperRecipes.init();
  });
});
